<template>
  <div class="main">
    <DetailsMenu :user="user" title="User Details" current="Details" />

    <div class="content p-3 p-md-4 px-xxl-5">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
        </div>

        <template v-if="!!user.is_icp_dealer && user.id == $root.user.id">
          <!-- ICP Dealer Users -->
          <div class="col-12 mb-4 col-lg-6 col-xxl-4">
            <DetailsPane
              :user="user"
              :hide-close="true"
              :hide-details-button="true"
              :show-full-details="true"
            />
          </div>
          <div class="col-12 col-lg-6 col-xxl-8">
            <FormWrapper :action="formAction" method="PUT">
              <div class="row">
                <div class="col-12 mb-3 col-xxl-6">
                  <h4 class="font-weight-bold mb-3">
                    Update your email address
                  </h4>
                  <Field
                    type="text"
                    name="email"
                    :value="user.email"
                    validate="required"
                  />
                </div>
                <div class="d-none d-xxl-flex col-xxl-6"></div>
                <div class="col-12 text-center text-xxl-left">
                  <div class="pt-xxl-2">
                    <button
                      class="btn btn-success d-inline-block mr-2"
                      type="submit"
                    >
                      Save Changes
                    </button>
                    <a
                      class="btn btn-info d-inline-block"
                      :href="route('training.users.index')"
                      >Cancel & Exit</a
                    >
                  </div>
                </div>
              </div>
            </FormWrapper>
          </div>
        </template>

        <template v-else-if="user.is_writein && user.can_update">
          <!-- Write-In Users -->
          <div class="col-12">
            <FormWrapper :action="formAction" method="PUT">
              <div class="row">
                <div class="col-12 mb-4 col-lg-8 col-xxl-9">
                  <div class="row">
                    <div class="col-12 mb-2">
                      <Field
                        type="text"
                        name="writein[company_name]"
                        label="Company"
                        :value="user.company.name || 'N/A'"
                        :disabled="true"
                        :readonly="true"
                      />
                      <input
                        type="hidden"
                        name="writein[company_id]"
                        :value="user.company_id"
                      />
                    </div>
                    <div class="col-12 mb-2 col-sm-6 col-xxl-3">
                      <Field
                        type="text"
                        name="writein[first_name]"
                        label="First Name"
                        :value="user.first_name"
                        validate="required"
                        validate-as="First Name"
                      />
                    </div>
                    <div class="col-12 mb-2 col-sm-6 col-xxl-3">
                      <Field
                        type="text"
                        name="writein[last_name]"
                        label="Last Name"
                        :value="user.last_name"
                        validate="required"
                        validate-as="Last Name"
                      />
                    </div>
                    <div class="col-12 mb-2 col-xxl-6">
                      <Field
                        type="text"
                        name="writein[email]"
                        label="Email"
                        :value="user.email"
                        validate="required"
                        validate-as="Email"
                      />
                    </div>
                    <div class="col-12 mb-2 col-xxl-6">
                      <Field
                        type="text"
                        name="writein[title]"
                        label="Title"
                        :value="user.title"
                      />
                    </div>
                    <div class="col-12 mb-2 col-sm-6 mb-sm-4 col-xxl-3">
                      <Field
                        type="text"
                        name="writein[phone]"
                        label="Phone"
                        :value="user.phone"
                      />
                    </div>
                    <div class="col-12 mb-4 col-sm-6 col-xxl-3">
                      <Field
                        type="text"
                        name="writein[fax]"
                        label="Fax"
                        :value="user.fax"
                      />
                    </div>
                    <div class="col-12">
                      <Field
                        type="checkbox"
                        id="writein_is_active"
                        name="writein[is_active]"
                        label="This user is ACTIVE"
                        :value="user.is_active"
                        :checkbox-value="1"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-4 col-xxl-3 form-button-wrapper">
                  <div class="sticky-top">
                    <div class="row">
                      <div class="col-12 text-center">
                        <button type="submit" class="btn btn-success mr-2">
                          Save Changes
                        </button>
                        <a
                          :href="route('training.users.index')"
                          class="btn btn-info"
                          >Cancel & Exit</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FormWrapper>
          </div>
        </template>

        <template v-else>
          <!-- All Other Users -->
          <div class="d-none d-lg-block col-lg-2 d-xl-none"></div>
          <div class="col-12 col-lg-8 col-xl-6 col-xxl-4">
            <DetailsPane
              :user="user"
              :hide-close="true"
              :hide-details-button="true"
              :show-full-details="true"
            />
          </div>
          <div class="d-none d-lg-block col-lg-2 col-xl-6 col-xxl-8"></div>
        </template>

        <div class="col-12 col-lg-8 col-xl-6 col-xxl-4 mt-4">
          <div class="details-pane py-4 px-2 d-none">
            <FormWrapper :action="formNotificationAction" method="PUT">
              <div class="col-12 mb-3">
                <Field
                    type="checkbox"
                    id="reminder_notifications_enabled"
                    name="reminder_notifications_enabled"
                    label="Enable notifications for reminders"
                    :value="user.reminder_notifications_enabled"
                    :checkbox-value="1"
                />
              </div>
              <button type="submit" class="btn btn-success mr-2 ml-2">
                Save Changes
              </button>
            </FormWrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import DetailsMenu from "./partials/DetailsMenu";
import DetailsPane from "components/partials/Users/DetailsPane";
import FormWrapper from "../../../forms/FormWrapper.vue";

export default {
  mixins: [DisplaysAlerts],
  components: {FormWrapper, DetailsMenu, DetailsPane },
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    formAction() {
      return this.route("training.users.update", { user: this.user.id });
    },
    formNotificationAction() {
      return this.route("training.users.updateNotifications", { user: this.user.id })
    }
  },
  watch: {},
};
</script>